import React from 'react';
import Bodenfeuchte from '../components/Bodenfeuchte';
import './home.css'; // gleiche Styles wie bei Home verwenden

function BodenfeuchteMondsee() {
  return (
    <div
      className="home-container"
      role="main"
      aria-labelledby="bodenfeuchte-mondsee-heading"
    >
      <div className="home-diagramm">
        <div className="wetter-container">
          <h1 id="bodenfeuchte-mondsee-heading">BODENFEUCHTE</h1>
        </div>

        <Bodenfeuchte ort="mondsee" />
      </div>
    </div>
  );
}

export default BodenfeuchteMondsee;
